<template>
  <ul class="main-header__menu">
    <li
      v-for="parent in items"
      :key="parent.id"
      v-if="parent.items.length > 0 || parent.url"
      :class="{
        active: visibleSubMenuId === parent.id,
      }"
      class="main-header__menu__item main-header__menu__item--0"
    >
      <template v-if="parent.items && parent.items.length > 0">
        <a
          class="main-header__menu__item__text main-header__menu__item__text--0 has-children"
          @click="toggleSubMenu(parent)"
          v-html="parent.label"
        >
        </a>
        <ul
          class="main-header__menu__sub-menu main-header__menu__sub-menu--0"
          :class="{
            active: visibleSubMenuId === parent.id,
            dark: parent.dark_mode,
          }"
        >
          <li class="main-header__menu__item main-header__menu__item--1">
            <a
              class="main-header__menu__item__text main-header__menu__item__text--1 arrow"
              @click="toggleSubMenu()"
              v-html="parent.label"
            >
            </a>
            <ul
              v-for="firstChild in parent.items"
              :key="firstChild.id"
              class="main-header__menu__sub-menu main-header__menu__sub-menu--2"
            >
              <li class="main-header__menu__item main-header__menu__item--2">
                <div
                  class="main-header__menu__item__text main-header__menu__item__text--2"
                  v-html="firstChild.label"
                ></div>
                <ul
                  class="main-header__menu__sub-menu main-header__menu__sub-menu--3"
                >
                  <li
                    v-for="secondChild in firstChild.items"
                    :key="secondChild.id"
                    class="main-header__menu__item main-header__menu__item--3"
                  >
                    <a
                      class="main-header__menu__item__text main-header__menu__item__text--3"
                      v-html="secondChild.label"
                      @click="goToUrl(secondChild)"
                    ></a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </template>
      <a
        class="main-header__menu__item__text main-header__menu__item__text--0"
        v-else-if="parent.url"
        @click="goToUrl(parent)"
        v-html="parent.label"
      ></a>
    </li>
  </ul>
</template>
<script>
export default {
  name: "AppMegaMenu",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    activeDropdown: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    onHide() {
      this.$emit("hide");
    },
    toggleSubMenu(item) {
      if (!this.activeDropdown || !item) {
        this.visibleSubMenuId = null;
      }

      if (item) {
        if (this.visibleSubMenuId === item.id) {
          this.$emit("close");
          this.visibleSubMenuId = null;
        } else {
          this.$emit("open");
          this.visibleSubMenuId = item.id;
        }
      }
    },
    goToUrl(item) {
      if (!item.url) {
        return;
      }
      window.location = item.url;
    },
  },
  data() {
    return {
      visibleSubMenuId: null,
    };
  },
};
</script>
